module.exports = __webpack_public_path__ + "images/emoji/fearful.cb20479b2f44ec83d343.png";